import React, { Component } from 'react';
import { request } from 'http';
import Q from './shared/Q'
import MySlider from './shared/MySlider'
// import MyInput from './shared/MyInput'

export default class Head extends Component {
	state={value:30}
	// componentWillUnmount() {
	// 	console.log("[!]\t componentWillUnmount")
	// 	const {value} = this.state
	// 	global.setAnswer('Age', value);
	// }
	componentDidMount() {
		const {value} = this.state
		global.setAnswer('Age', value);
	}
	render() {
		const {t,l} = this.props
		const {value} = this.state
		return <Q q="What is your age?" {...this.props}>
			<MySlider style={{
				position:"absolute",
				top:200,
				left:60
			}} value={value} txt="years old" min={0} max={120} cb={value => {
				if(this.timer) {
					clearTimeout(this.timer)
				}
				this.timer = setTimeout(() => {
					global.setAnswer('Age', value);
					this.timer = null
				}, 250)
				this.setState({value})
				
			}}/>
		</Q>
	}

}



// WEBPACK FOOTER //
// ./src/dComp/Age.js